var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBlueIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29786 5L0.618239 1.42259C0.283504 1.09715 0.283504 0.569515 0.618239 0.244078C0.952974 -0.0813592 1.49569 -0.0813592 1.83042 0.244078L6.11614 4.41074C6.45087 4.73618 6.45087 5.26382 6.11614 5.58926L1.83042 9.75592C1.49569 10.0814 0.952974 10.0814 0.618239 9.75592C0.283504 9.43049 0.283504 8.90285 0.618239 8.57741L4.29786 5Z",
    fill: "#9277FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlueIndicator);
export default __webpack_public_path__ + "static/media/right-blue-indicator.88d58b20269bfb1b0d000380dc37c9c8.svg";
export { ForwardRef as ReactComponent };